import { useParams } from "react-router-dom";

const CONTENT = {
  terms: {
    title: "Terms & Conditions",
    body: [
      ["Acceptance of Terms", "By accessing and using KK Beauty & Fashion (kkbeautyfashion.com), you accept and agree to be bound by these Terms & Conditions. If you do not agree, please discontinue use of the site."],
      ["Products & Pricing", "All products are subject to availability. We reserve the right to modify prices, discontinue products, or limit quantities at any time without prior notice. Promotional prices are valid only while the offer is active."],
      ["Orders", "Placing an order constitutes an offer to purchase. We reserve the right to accept or decline any order. Once payment is confirmed, you will receive an order confirmation."],
      ["Shipping", "We currently ship within the United States only. We do not accept, process, or fulfill orders for delivery outside the USA. Orders must be placed with a valid U.S. shipping address."],
      ["Intellectual Property", "All content on this site — including text, graphics, logos, and images — is the property of KK Beauty & Fashion and is protected by applicable copyright and trademark laws."],
      ["Limitation of Liability", "KK Beauty & Fashion shall not be liable for any indirect, incidental, or consequential damages arising from the use of our products or website."],
      ["Governing Law", "These terms are governed by the laws of the jurisdiction in which KK Beauty & Fashion operates."],
    ],
  },
  privacy: {
    title: "Privacy Policy",
    body: [
      ["Information We Collect", "We collect information you provide directly — such as your name, email, shipping address, and payment details — as well as data gathered automatically through cookies and analytics."],
      ["How We Use Your Information", "Your information is used to process orders, deliver products, provide customer support, and improve your shopping experience. We never sell your personal data to third parties."],
      ["Payment Security", "All payments are processed through secure, PCI-compliant payment providers. We do not store your full card details on our servers."],
      ["Cookies", "We use cookies to remember your cart, preferences, and to analyze site traffic. You may disable cookies through your browser settings."],
      ["Data Retention", "We retain your personal information only for as long as necessary to fulfill the purposes outlined in this policy or as required by law."],
      ["Your Rights", "You may request access to, correction of, or deletion of your personal data at any time by contacting our support team."],
    ],
  },
  refund: {
    title: "Refund Policy",
    body: [
      ["7-Day Returns", "We offer a 7-day return window from the date of delivery. Items must be unused, unopened, in their original packaging, and in resalable condition to qualify."],
      ["Non-Returnable Categories", "For health and hygiene reasons, Skincare and Bath & Body products are NOT eligible for return or refund once delivered — unless they arrive damaged or defective. Opened fragrance items are also non-returnable."],
      ["How to Request a Refund", "Email welcome@kkbeautyfashion.com or call 1-800-484-7959 within 7 days of delivery with your order number and reason for return. Once approved, we will provide return instructions."],
      ["Refund Processing", "Approved refunds are processed to your original payment method within 5–10 business days after we receive and inspect the returned item."],
      ["Damaged or Defective Items", "If your item arrives damaged or defective, please contact us within 48 hours of delivery with photos, and we will arrange a replacement or full refund."],
      ["Shipping Coverage & Costs", "We ship within the United States only and do not accept international orders. Original shipping charges are non-refundable, and return shipping costs are the responsibility of the customer unless the item was damaged or incorrect."],
    ],
  },
};

export default function Policy() {
  const { type } = useParams();
  const data = CONTENT[type] || CONTENT.terms;

  return (
    <div className="mx-auto max-w-3xl px-4 py-16 md:px-8">
      <p className="label-eyebrow">Legal</p>
      <h1 className="font-display mt-2 text-3xl font-light tracking-tight md:text-4xl" data-testid="policy-title">
        {data.title}
      </h1>
      <p className="mt-3 text-sm text-zinc-400">Last updated {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long" })}</p>

      <div className="mt-12 space-y-10">
        {data.body.map(([heading, text], i) => (
          <section key={i}>
            <h2 className="font-display text-lg text-zinc-900">{i + 1}. {heading}</h2>
            <p className="mt-3 text-sm leading-relaxed text-zinc-600">{text}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
